export default __webpack_public_path__ + "static/media/players_inventory.fe2ce1d2.jpg";